import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import useRedirectEstablishmentActiveContent from '../../../../Components/Hooks/useRedirectEstablishmentActiveContent';
import Search404 from '../../../AuthenticationInner/Errors/Search';
import ItemList from './ItemList';

const TransferList = () => {
    const { id } = useParams();	
    const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/warehouse/establishmentId/ppe/transfers');

    const breadcrumbLinks = [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Bodega' },
    ];

    if (id === 'all')
        return (
                <React.Fragment>
                        <UiContent />
                        <div className="page-content mb-10" style={{ paddingBottom: '90px' }}>
                                <Container fluid>
                                        <BreadCrumb title={`Lista de items `} hidden={true} />
                                        <Search404 />
                                </Container>
                        </div>
                </React.Fragment>
        )

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Transferencias' links={breadcrumbLinks} />
                    <ItemList establishment_id={id} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default TransferList;